import adminApiClient from './adminApiClient';

export const adminProfileService = {
  getProfile:     ()     => adminApiClient.get('/api/users/me'),
  updateProfile:  (data) => adminApiClient.put('/api/users/me', data),
  changePassword: (data) => adminApiClient.put('/api/users/me/password', data),
};

export default adminProfileService;
